import Route from '@ember/routing/route';

export default class AppShipmentsFiltersRoute extends Route {}
